import { render } from "./password-form.vue?vue&type=template&id=2aedb98b&scoped=true"
import script from "./password-form.vue?vue&type=script&lang=js"
export * from "./password-form.vue?vue&type=script&lang=js"

import "./password-form.vue?vue&type=style&index=0&id=2aedb98b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aedb98b"]])

export default __exports__